export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getAllProducts: () => {
            return JsonRPCService.send('pc', 'gateway/product', 'getAllProducts', []);
        }
    };
}];